import DateFnsUtils from '@date-io/date-fns';
import { createStyles, makeStyles, MuiThemeProvider } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import clsx from 'clsx';
import { es } from 'date-fns/locale';
import React from 'react';
import theme from '../../styles/theme';
var customTheme = theme;
var CustomDatePicker = function (_a) {
    var _b;
    var id = _a.id, className = _a.className, label = _a.label, value = _a.value, Icon = _a.Icon, minDate = _a.minDate, maxDate = _a.maxDate, dataTestId = _a.dataTestId, invalidDateMessage = _a.invalidDateMessage, minDateMessage = _a.minDateMessage, maxDateMessage = _a.maxDateMessage, readOnlyInput = _a.readOnlyInput, errorMessage = _a.errorMessage, disabled = _a.disabled, onBlur = _a.onBlur, onChange = _a.onChange;
    customTheme.overrides.MuiInputBase = {
        input: {
            disabled: {
                color: 'hsl(var(--valor-gris-l43), 0.6) !important',
            },
        },
    };
    customTheme.overrides.MuiInputLabel = {
        focused: {
            top: '0 !important',
        },
    };
    var useStyles = makeStyles(function () {
        return createStyles({
            disabled: {
                '--icon-primary-light': 'hsl(var(--valor-gris-l43), 0.6)',
            },
        });
    });
    return (React.createElement(MuiThemeProvider, { theme: customTheme },
        React.createElement(MuiPickersUtilsProvider, { locale: es, utils: DateFnsUtils }, !errorMessage ? (React.createElement(KeyboardDatePicker, { "data-testid": dataTestId, disableToolbar: true, variant: "inline", inputVariant: "outlined", format: "dd/MM/yyyy", margin: "normal", id: id, className: clsx(className, (_b = {},
                _b[useStyles().disabled] = disabled,
                _b)), label: label, value: value, maxDate: maxDate, minDate: minDate, onBlur: onBlur, onChange: onChange, invalidDateMessage: invalidDateMessage, minDateMessage: minDateMessage, maxDateMessage: maxDateMessage, disabled: disabled, autoOk: true, KeyboardButtonProps: {
                'aria-label': 'change date',
            }, keyboardIcon: React.createElement(Icon, null), PopoverProps: {
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
            }, InputProps: {
                style: {
                    height: 46,
                },
                readOnly: readOnlyInput,
            }, InputLabelProps: {
                style: {
                    top: value ? '0' : '-4px',
                    color: disabled ? 'hsl(var(--valor-gris-l43), 0.6)' : 'var(--gray80)',
                },
            } })) : (React.createElement(KeyboardDatePicker, { "data-testid": dataTestId, disableToolbar: true, variant: "inline", inputVariant: "outlined", format: "dd/MM/yyyy", margin: "normal", id: id, className: className, label: label, value: value, maxDate: maxDate, minDate: minDate, onBlur: onBlur, onChange: onChange, invalidDateMessage: invalidDateMessage, minDateMessage: minDateMessage, maxDateMessage: maxDateMessage, helperText: errorMessage, disabled: disabled, error: true, autoOk: true, KeyboardButtonProps: {
                'aria-label': 'change date',
            }, keyboardIcon: React.createElement(Icon, null), PopoverProps: {
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
            }, InputProps: {
                style: {
                    height: 46,
                },
                readOnly: readOnlyInput,
            }, InputLabelProps: {
                style: {
                    top: value ? '0' : '-4px',
                    color: disabled ? 'hsl(var(--valor-gris-l43), 0.6)' : 'var(--gray80)',
                },
            } })))));
};
CustomDatePicker.defaultProps = {
    label: '',
    placeholder: '',
    className: '',
    errorMessage: undefined,
    disabled: false,
    readOnlyInput: false,
};
export default CustomDatePicker;
